import { useEffect } from 'react'
import { getSlugPartner } from '../utils'

export const usePartner = (setPartner) => {
  useEffect(() => {
    const partner = getSlugPartner()
    setPartner(partner)
  }, [setPartner])
}
